import { Card, CardContent, FormControl, InputLabel, Select } from "@mui/material";
import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../../canalDist/canalDist.controll";
import { connect } from "react-redux";
import { FormCad } from "../../../components/viewCadastro/formCad";
import { DemonstrativoType } from "../../canalDist/canalDist.model";

function CardPeriodo(props: CanalDistribuicaoViewProps) {
    const { filtroMovCanal } = props.canalDistribuicaoState
    const { setFiltro } = props.canalDistribuicaoActions
    const handleConfirmePeriodo = (value: any) => {
        setFiltro(value);
    }
    return (
        <Card variant="outlined" sx={{ p: 0.5, flexShrink: 0 }} >

            <FormCad
                row={filtroMovCanal}
                contentForm={[
                    { fieldName: "dtIni", label: "Período de:", type: "data", key: "dataIni", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true },
                    { fieldName: "dtFim", label: "Até:", type: "data", key: "dataFim", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true },
                    { fieldName: "periodo", label: "Demonstrativo", type: "select", key: "periodo", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true, radioOptionsValues:[{label:"Anual",value:"anual"},{label:"Mensal",value:"mensal"},{label:"Diario",value:"diario"},] },
                ]}
                handleOnSubmit={handleConfirmePeriodo}
                handleMutator={() => { }}
                handleCancel={() => { }}
                buttonActions={[{ type: "submit", label: "Aplicar", color: "primary", variant: "contained" }]}
                buttonInsider={true}
            />

        </Card>
    )
}
export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(CardPeriodo);